import {createApp} from 'vue'
import ActiveRoleListCard from './ActiveRoleListCard'

const el = '.kb-component--active-role-list-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ActiveRoleListCardDOM)=>{
            const roleCardData = ActiveRoleListCardDOM.dataset.roleCard 
            ? JSON.parse(ActiveRoleListCardDOM.dataset.roleCard) 
            : null
            const component = createApp(ActiveRoleListCard, {roleCardData}).use(Store)
            component.mount(ActiveRoleListCardDOM)
        })
    }
}